// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__HpKSV","page_title":"index_page_title__R_K_T"};